// extracted by mini-css-extract-plugin
export default {"button":"Uj-z","reviewSort":"Vj-z"};